module.exports = __webpack_public_path__ + "img/qantas_logo.fb726569.svg";